"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { list: [] };
    },
    onMount: function () {
        this.fetchFeatured();
    },
    fetchFeatured: async function () {
        try {
            const {error, message, extensions} = await MPSRequest('/extension/list');
            if (error)
                throw new Error(message);
            this.state.list = extensions.map(value => ({
                value,
                sort: Math.random()
            })).sort((a, b) => a.sort - b.sort).map(({value}) => value).slice(0, 8);
        } catch (error) {
            console.log('Failed fetching featured: ', error);
            this.state.list = [];
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Marketplace/components/Featured/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("../../../Favicon.marko"),
    Favicon_tag = marko_loadTag(Favicon_template),
    StarRating_template = require("../../../../../components/StarRating/index.marko"),
    StarRating_tag = marko_loadTag(StarRating_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "px-3 py-2 theme-bg-transparent"
      },
    marko_attrs1 = {
        "class": "card theme-bg"
      },
    marko_attrs2 = {
        "class": "card-content"
      },
    marko_attrs3 = {
        style: "height:120px",
        "class": "d-flex align-items-center justify-content-center"
      },
    marko_attrs4 = {
        "class": "px-1 py-75"
      },
    marko_attrs5 = {
        "class": "mb-2"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  out.be("h5", null, "1", component);

  Locale_tag({
      text: "Featured",
      class: "font-medium-1"
    }, out, __component, "2");

  out.ee();

  Row_tag(marko_mergeNestedTagsHelper({
      renderBody: function(out, $nestedTagRow$0) {
        var $for$0 = 0;

        marko_forOf(state.list, function(each, index) {
          const { name, description, nsi, version, favicon } = each

          var $keyScope$0 = "[" + (($for$0++) + "]");

          Row_col_nested_tag({
              qs: "col-6",
              hs: "col-lg-3 col-md-3 col-sm-4",
              fs: "col-lg-2 col-sm-6",
              class: "cursor-pointer",
              renderBody: function(out) {
                out.be("div", marko_attrs1, "5" + $keyScope$0, component, null, 0, {
                    onclick: __component.d("click", () => component.emit('open', each ), false)
                  });

                out.be("div", marko_attrs2, "6" + $keyScope$0, component);

                out.be("div", marko_attrs3, "7" + $keyScope$0, component);

                Favicon_tag(marko_assign({
                    width: 44
                  }, each, {
                    class: "font-large-1"
                  }), out, __component, "8" + $keyScope$0);

                out.ee();

                out.be("div", marko_attrs4, "9" + $keyScope$0, component);

                out.e("p", marko_attrs5, "10" + $keyScope$0, component, 1)
                  .t(name, component);

                out.be("div", null, "11" + $keyScope$0, component);

                if ((input.installing.nsi == nsi) && (input.installing.status == "ONGOING")) {
                  Locale_tag({
                      text: "installing",
                      class: "font-small-2 float-right text-warning"
                    }, out, __component, "12" + $keyScope$0);
                } else if ((input.installing.nsi == nsi) && (input.uninstalling.status == "ONGOING")) {
                  Locale_tag({
                      text: "uninstalling",
                      class: "font-small-2 float-right text-warning"
                    }, out, __component, "13" + $keyScope$0);
                } else if (window.Extensions.isInstalled((nsi + "~") + version)) {
                  Locale_tag({
                      text: "Installed",
                      class: "font-small-2 float-right text-success"
                    }, out, __component, "14" + $keyScope$0);
                }

                StarRating_tag({
                    score: 4.5,
                    size: "12",
                    color: "grey"
                  }, out, __component, "15" + $keyScope$0);

                out.ee();

                out.ee();

                out.ee();

                out.ee();
              }
            }, $nestedTagRow$0);
        });
      }
    }), out, __component, "3");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
